<template>
  <div class="image-wrapper" v-if="column.dataIndex === 'marketplace'">
    <img
      :src="MARKET_PLACE_ICON_BY_TYPE[record[column.dataIndex]]"
      :alt="MARKET_PLACE_NAME_BY_TYPE[record[column.dataIndex]]"
    />
  </div>

  <a-flex
    justify="center"
    align="center"
    v-else-if="isCopyableCell(column.dataIndex)"
  >
    <CopyableText
      :absolute="true"
      :text="record[column.dataIndex]"
      :copy-text="record[column.dataIndex]?.toString()"
    >
    </CopyableText>
  </a-flex>

  <a-flex
    v-else-if="column.dataIndex === 'actions'"
    gap="middle"
    justify="center"
    align="center"
  >
    <a-tooltip
      :title="action.tooltip"
      v-for="action in markingCodesRegistryStore.actions"
      :key="action.tooltip"
    >
      <a-button class="icon-button" @click="action.handler(record)">
        <component :is="action.icon" />
      </a-button>
    </a-tooltip>
  </a-flex>

  <span v-else class="default-cell">{{ record[column.dataIndex] }}</span>
</template>

<script setup lang="ts">
import {
  type MarkingCodesRegistryTableItem,
  useMarkingCodesRegistry,
} from "@/stores/product/marking/marking-codes-registry.store";
import {
  MARKET_PLACE_ICON_BY_TYPE,
  MARKET_PLACE_NAME_BY_TYPE,
} from "@/types/market-place";
import CopyableText from "@/components/UI/CopyableText.vue";

defineProps<{
  column: {
    dataIndex: keyof MarkingCodesRegistryTableItem;
    title: string;
  };
  record: MarkingCodesRegistryTableItem;
}>();

const markingCodesRegistryStore = useMarkingCodesRegistry();

const isCopyableCell = (dataIndex: keyof MarkingCodesRegistryTableItem) => {
  const copyableColumns: (keyof MarkingCodesRegistryTableItem)[] = [
    "code",
    "barcode",
    "sellerArticle",
    "gtin",
    "supply",
    "order",
    "document",
  ];

  return copyableColumns.includes(dataIndex);
};
</script>

<style scoped lang="scss">
.image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  justify-self: center;
  margin: 0 auto;

  img {
    width: 100%;
    height: 100%;
  }
}

.icon-button {
  --size: 24px;

  height: var(--size);
  width: var(--size);
  font-size: var(--size);
  line-height: var(--size);
  background: none;
  border: none;
  padding: 0;

  svg {
    height: 100%;
    width: 100%;
  }
}

.default-cell {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
